<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import type { BreadcrumbLinkItem } from './BreadcrumbLink.vue';
import BreadcrumbLink from './BreadcrumbLink.vue';

const { item } = defineProps<{
  /**
   * The item to display in the breadcrumb.
   *
   * If an array is passed, the component will check for the matching route and display.
   */
  item: BreadcrumbLinkItem | Array<BreadcrumbLinkItem>;
}>();

const route = useRoute();
const isCurrentRoute = (to: string) => {
  if (typeof to === 'string') {
    return route.name === to || route.path === to;
  }

  return false;
};

const currentRouteToRender = computed(() => {
  if (Array.isArray(item)) {
    return item.find((subItem) => isCurrentRoute(subItem.to.name));
  }

  return item;
});
</script>

<template>
  <template v-if="currentRouteToRender != null">
    <BreadcrumbLink :item="currentRouteToRender" />
  </template>
  <template v-else-if="!Array.isArray(item)">
    <BreadcrumbLink :item="item as BreadcrumbLinkItem" />
  </template>
</template>

<style scoped></style>
